<template>
    <!--上导航栏-->
    <div class="bar-wrap">
        <div class="Top-bar">
            <div class="bar-left">
<!--                <div class="logo">-->
<!--                    <img src="../../assets/img/LOGO.png" alt="logo">-->
<!--                </div>-->
<!--                <h1 class="left-title">成人高考考前辅导平台</h1>-->
                <img :src="indexLogoUrl" alt="logo">
            </div>
            <div class="bar-mid">
                <router-link
                        tag="span"
                        :to="titleList[0].route"
                        :class="{hover:titleList[0].route === nowRoute}"
                >
                    {{titleList[0].title}}
                </router-link>
                <span :class="{hover:titleList[1].route === nowRoute}" @click="goQuestion">
                    {{titleList[1].title}}
                </span>
                <router-link
                        tag="span"
                        :to="titleList[2].route"
                        :class="{hover:titleList[2].route === nowRoute}"
                >
                    {{titleList[2].title}}
                </router-link>
              <router-link
                  tag="span"
                  :to="titleList[3].route"
                  :class="{hover:titleList[3].route === nowRoute}"
              >
                {{titleList[3].title}}
              </router-link>
            </div>
            <div class="bar-right">
                <div class="right-tips" v-if="major">
                    <img src="../../assets/img/book.png" alt="书">
                    <span>{{major}}</span>
                </div>
                <div class="right-student">
                    <div class="name">{{stu_name}}</div>
                    <div class="portrait" @click="logoutLogin = !logoutLogin">

                        <img src="../../assets/img/portrait.png" alt="头像" v-if="user_img.length==0">
                      <img :src="user_img" alt="头像" class="userImg" v-else>
                    </div>
                    <div class="logout" v-show="logoutLogin" @click="logoutLoginFun()">退出登录</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "TopBar",
        props: {
            TopBarData:{
                type:Array,
                default:function () {
                    return ['','']
                }
            }
        },
        data() {
            return {
                indexLogoUrl:'http://c.zikaoj.com/1609144966.8182173.png',
                logoutLogin: false,
                topBarType: 'MyCourse',
                titleList: [
                    {title: "我的课程", route: '/MyCourse'},
                    {title: "我的题库", route: '/MyQuestion'},
                    {title: "我的错题", route: '/MyWrongTopic'},
                    {title: "我的报考信息", route: '/StudentInfo'}
                ],
                nowRoute: '/MyCourse',
                stu_name: '',
                major: '',
                user_img:''
            }
        },
        created() {
           let pcBgUrl= JSON.parse(localStorage.getItem('academyInfo')).kqfdPCUrl;
            if(pcBgUrl != '' & pcBgUrl != undefined){
                this.indexLogoUrl = pcBgUrl
            }
        },
        mounted() {
            this.nowRouteFun();
        },
        methods: {
            logoutLoginFun() {
                const poUrl = localStorage.getItem('loginUrl');
                localStorage.clear();
                localStorage.setItem('loginUrl', poUrl)

                this.$router.push('/login')

                this.$message.success("退出成功！")
            },
            //现在的路由
            nowRouteFun() {
                this.stu_name = localStorage.getItem('stu_name');
                this.major = localStorage.getItem('major');
                const student = JSON.parse(localStorage.getItem('student') );
                if (student.user_img != undefined){
                  this.user_img = student.user_img;
                }


                if (this.$route.path === '/CourseMessage' || this.$route.path === '/PlayVideo') {
                    return this.nowRoute = '/MyCourse';
                } else if (this.$route.path === '/AnswerExercises' || this.$route.path === '/AnswerSheet' || this.$route.path === '/AnswerReport' || this.$route.path === '/QuestionMessage') {
                    return this.nowRoute = '/MyQuestion';
                } else if (this.$route.path === '/ErrQuestion' || this.$route.path === '/WrongTopicMessage') {
                    return this.nowRoute = '/MyWrongTopic';
                } else if (this.$route.path === '/StudentInfo') {
                  return this.nowRoute = '/StudentInfo';
                } else {
                    if (this.$route.path === '/myQuestion') {
                        this.nowRoute = '/MyQuestion';
                    } else {
                        this.nowRoute = this.$route.path;
                    }
                }
            },
            goQuestion(){
                if(this.TopBarData.length === 0){
                    this.TopBarData[0] ='';
                    this.TopBarData[1] ='';
                }
                this.$router.push({
                    path: '/myQuestion',
                    query: {
                        crs_id: this.TopBarData[0],
                        type: this.TopBarData[1],
                    }

                })
            }
        }
    }
</script>

<style lang="scss" scoped>
    .bar-wrap {
        position: fixed;
        top: 0;
        width: 100vw;
        margin: 0 auto;
        background-color: #ffffff;
        box-shadow: 0 -5px 9px 0 #aaaaaa;
        z-index: 100;
        .Top-bar {
            width: 1200px;
            height: 85px;
            margin: 0 auto;
            display: flex;
            justify-content: space-between;
            align-items: center;
            .bar-left {
                display: flex;
                align-items: center;
                .logo {
                    width: 48px;
                    height: 48px;
                    border-radius: 50%;
                    margin-right: 13px;
                    img {
                        display: inline-block;
                        font-size: 0;
                        width: 48px;
                    }
                }
                .left-title {
                    font-size: 20px;
                    line-height: 48px;
                    font-family: PingFang SC;
                    color: #333333;
                    cursor: pointer;
                    font-weight: 400;
                }
            }
            .bar-mid {
                font-family: PingFang SC;
                font-size: 16px;
                line-height: 48px;
                color: #333333;
                span {
                    font-weight: 400;
                    display: inline-block;
                    margin-right: 40px;
                    cursor: pointer;
                }
                .hover {
                    position: relative;
                    color: #3D89FB;
                    &:before {
                        content: "";
                        position: absolute;
                        left: 0;
                        right: 0;
                        bottom: 0;
                        height: 3px;
                        border-radius: 3px;
                        background-color: #3D89FB;
                    }
                }
            }
            .bar-right {
                display: flex;
                line-height: 48px;
                height: 48px;
                width: 35%;
                .right-tips {
                    position: relative;
                    display: flex;
                    align-items: center;
                    padding-right: 17px;
                    width: 70%;
                    span {
                        display: inline-block;
                        margin-left: 7px;
                        font-size: 16px;
                        color: #666666;
                        overflow: hidden;
                        white-space: nowrap;
                        text-overflow: ellipsis;
                    }
                    &:before {
                        content: "";
                        position: absolute;
                        top: 16px;
                        right: 0;
                        bottom: 0;
                        border-right: 1px solid #999;
                        -webkit-transform: scaleY(.5);
                        -webkit-transform-origin: 0 0;
                    }
                }
                .right-student {
                    position: relative;
                    display: flex;
                    align-items: center;
                    padding-left: 16px;
                    .name {
                        font-family: PingFang SC;
                        font-size: 16px;
                        color: #666666;
                        font-weight: 400;
                        margin-right: 9px;
                    }
                    .portrait {
                        margin-top: 8px;
                        height: 48px;
                        cursor: pointer;
                        img {
                            font-size: 0;
                            display: inline-block;
                            width: 33px;
                        }
                    }
                    .logout {
                        position: absolute;
                        left: 0;
                        right: 0;
                        bottom: -40px;
                        text-align: center;
                        line-height: 36px;
                        border-radius: 4px;
                        font-size: 14px;
                        font-family: PingFang SC;
                        font-weight: 400;
                        color: #666;
                        cursor: pointer;
                        box-shadow: 0px 3px 6px #d2d2d2;
                        background-color: #fff;
                    }
                }
            }
        }
    }
    .userImg{
      width: 33px;
      height: 33px;
      border-radius: 40px;
      object-fit: cover
    }
</style>
